import { NewJoinersAndAllocationsFormTemplate } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewJoinersAndAllocationsModal/NewJoinersAndAllocationsStepsComponents/NewJoinersAndAllocationsKYC/useNewJoinersAndAllocationsKYCController';
import { uploadFile } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import { DataCustomDetailTct } from '@dealstack/shared/lib/generated';
import { showPreviewDocumentFromStream } from '@dealstack/frontend/shared/documentPreview';
import { useWrappedRequest } from '@dealstack/frontend/shared/other/react/ApiWrapper';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID';
import { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { CustomDetailEnum } from '@dealstack/shared/lib/generated/models/CustomDetailEnum.ts';
import { useDownloadedFileBlobMutation } from '@dealstack/frontend/shared/modules/document/file/hooks/useDownloadedFileBlobMutation';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';

export const useNewJoinersAndAllocationsFormsTemplatesTableController = (
	type: DataCustomDetailTct['type']
) => {
	const { dealId } = useRequiredParams('dealId');
	const { downloadedFileBlob } = useDownloadedFileBlobMutation();
	const uploadFileRequest = useWrappedRequest(uploadFile);

	const mainForm = useFormContext();

	const mainFormFieldName =
		type === CustomDetailEnum.INDIVIDUAL ? 'individualFormsTemplates' : 'pivFormsTemplates';

	const { append, remove } = useFieldArray({
		name: mainFormFieldName,
		control: mainForm.control,
		// we use keyName to prevent override backend contract id by rhf in fields
		keyName: 'key' as 'id',
	});
	const formsTemplates: NewJoinersAndAllocationsFormTemplate[] =
		mainForm.watch(mainFormFieldName);

	useEffect(() => {
		const file = uploadFileRequest.response?.payload;
		if (!file?.id) {
			return;
		}

		const formTemplate: NewJoinersAndAllocationsFormTemplate = {
			id: generateUUID(),
			local: true,
			name: '',
			instruction: '',
			type,
			fileId: file.id,
			fileName: file.name,
		};

		append(formTemplate);
	}, [uploadFileRequest.response?.payload]);

	const onRemoveRowClicked = (rowID: string) => {
		const indexToRemove = formsTemplates.findIndex((item) => item.id === rowID);
		if (indexToRemove < 0) {
			return;
		}
		remove(indexToRemove);
	};

	const showPreviewDocument = async (id: string) => {
		const contractItem = formsTemplates.find((item) => item.id === id);

		if (!contractItem) {
			return;
		}

		const data = await downloadedFileBlob({
			fileId: contractItem.fileId ?? '',
			dealId,
		});

		await showPreviewDocumentFromStream(data.blob);
	};

	return {
		onRemoveRowClicked,
		mainForm,
		mainFormFieldName,
		formsTemplates,
		uploadFileRequest,
		showPreviewDocument,
	};
};
